export default __webpack_public_path__ + "img/i-nav-favorite.bf78da9c.svg";